export default defineNuxtPlugin(() => {
    const key = 'foldwrap_session_id'

    // Check if session ID already exists
    if (!localStorage.getItem(key)) {
        // Generate a random UUID
        const sessionId = crypto.randomUUID()
        localStorage.setItem(key, sessionId)
        // console.log('💠 > sessionId generated', sessionId)
    }
    // else {
    // console.log('💠 > sessionId already exists', localStorage.getItem(key))
    // }
})
